import Axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { emissionKeys } from "src/query-keys";
import { PointSourceEmission, APIError } from "src/types";

export function usePointSourceEmision(
  scenarioId: number | string,
  emissionId: number | string,
  options?: UseQueryOptions<PointSourceEmission, AxiosError<APIError[]>, PointSourceEmission>
) {
  async function queryFn(scenarioId: number | string): Promise<PointSourceEmission> {
    const result = await Axios.get(`/planning-api/scenarios/${scenarioId}/pointsourceemissions/${emissionId}`);
    return result.data;
  }

  // TODO: can this be improved by using the `useEmissions` cache?
  return useQuery<PointSourceEmission, AxiosError<APIError[]>, PointSourceEmission>(
    emissionKeys.detail(scenarioId, emissionId),
    () => queryFn(scenarioId),
    options
  );
}
